/*
*
* File JS componente Header
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//

import Headroom from "headroom.js";

// IMPORT ATOMS
//--------------------------------------------------------------------//

 
// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './header.scss';

//--------------------------------------------------------------------//


/**
*	Script per il componente Header
*
*
*	@since  0.0.2
*	@author Guccy - IM*MEDIA
*
*	@return {void}
*/
const header = () =>
{

    /* Individuiamo dal DOM tutti gli elementi dell'header
    --------------------------------------------------------------------------*/
    const context = document.querySelector('#header');
    if( context === null ) return false;

    const navExpand = 1100;

    // /* Menu e megamenu
    // --------------------------------------------------------------------------*/
    const burgermenu = context.querySelector('.header__burger');

    /*/ Al click sul Burgermenu
    --------------------------------------------------------------------------*/
    if( burgermenu )
    {
        burgermenu.addEventListener('click', e=>
        {
            context.classList.toggle('mainmenu-opened');
            body.classList.toggle('mainmenu-opened');
        });
    }

    // /* Menu DropDown
    // --------------------------------------------------------------------------*/
    const subMenus  = context.querySelectorAll('.header__menu ul > li.dropdown');
    const iconDropdownDesk = '<div class="submenu-indicator desk"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_chevron-down"></use></svg></div>';
    const iconDropdownMob = '<div class="submenu-indicator mobile"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_arrow-up"></use></svg></div>';


    /*/ Funzione di apertura del submenu
    // --------------------------------------------------------------------------*/
    function openSubMenu(el)
    {
        el.classList.add('open');
        context.classList.add('submenu-opened');  
        body.classList.add('submenu-opened');

        //Nel caso di NavCompressed
        if (window.innerWidth < navExpand)
        {
            let paddingSubMenu = 40;
            let heightSubmenu = 0;
            let elementsInSub = el.querySelectorAll(':scope .dropdown-menu > li');

            //Calcolo per dare l'altezza al subMenu
            elementsInSub.forEach(element => 
            {
                heightSubmenu = heightSubmenu + element.offsetHeight;
            });

            el.querySelector(':scope .dropdown-menu').style.height = (heightSubmenu + paddingSubMenu) + 'px';
        }
    }

    /*/ Funzione di chiusa del submenu
    // --------------------------------------------------------------------------*/
    function closeSubMenu(el)
    {
        el.classList.remove('open');
        context.classList.remove('submenu-opened');
        body.classList.remove('submenu-opened');


        //Nel caso di NavCompressed
        if (window.innerWidth < navExpand)
        {
            el.querySelector(':scope .dropdown-menu').style.height = '';
        }
    }

    /*/ Aggiunta di EvetListner + Icona a tutti i subMenus
    // --------------------------------------------------------------------------*/

    subMenus.forEach((item, i) => {
        // Add icon dropdown
        item.firstElementChild.innerHTML += iconDropdownDesk;
        item.firstElementChild.innerHTML += iconDropdownMob;


        item.addEventListener('click', () => {

        // Chiudi tutti i submenu tranne quello attuale
        subMenus.forEach((submenu, index) => {
            if (index !== i && submenu.classList.contains('open')) {
                closeSubMenu(submenu);
            }
        });

        // Toggle del sottomenu attuale
        item.classList.contains('open') ? closeSubMenu(item) : openSubMenu(item); 
        });
    
    });

    /**
    *   Funzione per il bug transition del resize del header
    *
    *   @return {void}
    */

    function disableTransitionResize()
    {

        document.addEventListener('DOMContentLoaded', function() {
            
            let resizeTimer;
            const menuContainer = document.querySelector('.header__menu');
        
            window.onresize = () => {
                menuContainer.classList.add('no-transition');
            
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    menuContainer.classList.remove('no-transition');
                }, 250);
            };
        });
        
    }

    disableTransitionResize();

    // --------------------------------------------------------------------------*/
    
   
    /*/ Funzione di Headroom
    // --------------------------------------------------------------------------*/
    const headroom = new Headroom(context);
    headroom.init();
    


}


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

export default header;

//--------------------------------------------------------------------//